export default function () {
  const widgetName = 'gridGallerySmall';
  const widgetOpts = gridGallerySmallOpts;
  const $widget = $(`#${widgetName}`);

  const linkedImages = true;
  const linkNewTab = false;

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: linkedImages ? ['all'] : [''],
    hasImages: true,
    textOverImage: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    maxItemsVisible: 12,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      $widget.find('.card-content').remove();

      if (widgetData.length <= 0) {
        $widget.remove();
      } else {
        changeFormatCards(widgetData);
      }
    },
  });

  function changeFormatCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const { URL } = widgetData[x];
      const $card = $(this);

      if (!URL) {
        $card.removeAttr('href');
      }
      if (!linkNewTab) {
        $card.removeAttr('target');
      }
      if (linkedImages) {
        $card.addClass('linked-images');
      }
    });
  }
}
